import React, { useState } from "react";
import { useHistory, Link } from "react-router-dom";
import { Button } from "@windmill/react-ui";
import { ImFacebook, ImGoogle } from "react-icons/im";
import LabelArea from "../components/form/LabelArea";
import InputArea from "../components/form/InputArea";
import ImageLight from "../assets/img/login-office.jpeg";
import ImageDark from "../assets/img/login-office-dark.jpeg";
import useLoginSubmit from "../hooks/useLoginSubmit";
import language from "../../language";
import Swal from "sweetalert2";
import './trips.css'
// API
import { loginOperator } from "../../actions/auth";
// Redux
import { connect } from "react-redux";
import propTypes from "prop-types";
import store from "../../store";
import logo from '../../client/assets/FInalLogo.png'

const OperatorLogin = ({ loginOperator }) => {
  const history = useHistory();
  let languageSelectedEnglish =
    sessionStorage.getItem("language") === "english" ||
      !sessionStorage.getItem("language")
      ? true
      : false;

  const [user, setUser] = useState({
    email: "",
    password: "",
  });

  const handleUserData = (e) => {
    setUser({
      ...user,
      [e.target.name]: e.target.value,
    });
  };

  const handleLoginSubmit = () => {
    let loginObj = {
      email: user.email,
      password: user.password,
      role: 'operator'
    };
    if (!user.email || !user.password) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Please fill in both fields",
      });
      return;
    }
    console.log(loginObj);
    loginOperator({ loginObj, history });
  };
  return (
    <>
      <div className="flex items-center min-h-screen p-6 bg-gray-50">
        <div className="flex-1 h-full max-w-4xl mx-auto overflow-hidden bg-white rounded-lg shadow-xl">
          <div className="flex flex-col overflow-y-auto md:flex-row">
            <div className="h-32 md:h-auto md:w-1/2 operLogoOuter">
              <img
                aria-hidden="true"
                className="operatorLogo"
                src={logo}
                alt="Office"
              />
            </div>
            <main className="flex items-center justify-center p-6 sm:p-12 md:w-1/2">
              <div className="w-full">
                <h1 className="mb-6 text-2xl font-semibold text-gray-700">
                  {languageSelectedEnglish ? "Operator Login" : language.login}
                </h1>
                <form>
                  <LabelArea
                    label={languageSelectedEnglish ? "Email" : language.email}
                  />
                  <InputArea
                    value={user.email}
                    onChange={(e) => handleUserData(e)}
                    label={languageSelectedEnglish ? "Email" : language.email}
                    name="email"
                    type="email"
                    placeholder="john@doe.com"
                  />
                  <div className="mt-6"></div>
                  <LabelArea
                    label={
                      languageSelectedEnglish ? "Password" : language.password
                    }
                  />
                  <InputArea
                    value={user.password}
                    onChange={(e) => handleUserData(e)}
                    label={
                      languageSelectedEnglish ? "Password" : language.password
                    }
                    name="password"
                    type="password"
                    placeholder="***************"
                  />
                  <Button
                    className="mt-4 h-12 w-full newBtnColor"
                    onClick={handleLoginSubmit}
                  >
                    {languageSelectedEnglish ? "Log in" : language.login}
                  </Button>
                  <hr className="my-10" />
                </form>

                <p className="mt-4">
                  <Link
                    className="text-sm font-medium noTextDecor hover:underline"
                    to="/client/forgot-password"
                  >
                    {languageSelectedEnglish
                      ? "Forgot your password?"
                      : language.forgotYourPassword}
                  </Link>
                </p>
                <p className="mt-1">
                  <Link
                    className="text-sm font-medium noTextDecor hover:underline"
                    to="/operator/signup"
                  >
                    {languageSelectedEnglish
                      ? " Create account"
                      : language.createAccount}
                  </Link>
                </p>
              </div>
            </main>
          </div>
        </div>
      </div>
    </>
  );
};

OperatorLogin.propTypes = {
  loginOperator: propTypes.func.isRequired,
};

export default connect(null, { loginOperator })(OperatorLogin);
